export const MAX_SHOP_RELATED_ADS = 4;

export const MAX_USER_RELATED_ADS = 8;
